import Link from 'next/link';
import Tooltip from '@deprecated-ui/common/Tooltip';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';
import { VerifiedStatus } from 'lib/api/verifiedBadge';

const URL_VERIFICATION_ARTICLE =
  'https://help.stockbit.com/id/article/bagaimana-cara-mengajukan-verifikasi-akun-stockbit-6omqkl/';

function GreenVerifiedBadge() {
  return (
    <Tooltip
      placement="right"
      title={
        <Text size="12px" color={color.light} padding="6px 6px" height="18px">
          <Text as="span" family="bold" color={color.light} size="12px">
            Verified Account
          </Text>
          <br />
          Stockbit sudah mengkonfirmasi keaslian dan kelayakan akun ini.&nbsp;
          <Link
            href={URL_VERIFICATION_ARTICLE}
            onClick={(e) => e.stopPropagation()}
            target="_blank"
            rel="noreferrer noopener"
          >
            Pelajari Lebih Lanjut
          </Link>
        </Text>
      }
    >
      <Image
        src="/icon/widget-trending/icon-verified.svg"
        style={{ width: '12px', marginLeft: 5 }}
        alt="icon-verified"
      />
    </Tooltip>
  );
}

function GreyVerifiedBadge() {
  return (
    <Tooltip
      placement="right"
      title={
        <Text size="12px" color="#858585" padding="6px 6px" height="18px">
          <Text as="span" family="bold" color={color.light} size="12px">
            Account Verified
          </Text>
          <br />
          Identitas user telah terverifikasi sebagai nasabah Stockbit Sekuritas
        </Text>
      }
    >
      <Image
        src="/icon/verified-grey.svg"
        style={{ width: '12px', marginLeft: 4 }}
        alt="icon-verified"
      />
    </Tooltip>
  );
}

interface IProps {
  deprecatedVerifiedStatus: boolean;
  verifiedStatus?: VerifiedStatus;
}

function LabelVerifiedAccount({
  deprecatedVerifiedStatus,
  verifiedStatus,
}: IProps) {
  if (verifiedStatus === VerifiedStatus.VERIFIED_STATUS_COMMUNITY) {
    return <GreenVerifiedBadge />;
  }
  if (verifiedStatus === VerifiedStatus.VERIFIED_STATUS_IDENTITY) {
    return <GreyVerifiedBadge />;
  }
  if (deprecatedVerifiedStatus && verifiedStatus === undefined) {
    return <GreenVerifiedBadge />;
  }
  return null;
}

export default LabelVerifiedAccount;
